import { render, staticRenderFns } from "./BulkSchema.vue?vue&type=template&id=36da803c&scoped=true&"
import script from "./BulkSchema.vue?vue&type=script&lang=ts&"
export * from "./BulkSchema.vue?vue&type=script&lang=ts&"
import style0 from "./BulkSchema.vue?vue&type=style&index=0&id=36da803c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da803c",
  null
  
)

export default component.exports